/**
 * Product display helpers — domain-specific visibility (e.g. hide RAM/Storage on Handywelt).
 */

const formatVariants = (variants) => {
  if (!Array.isArray(variants) || variants.length === 0) return "";
  return variants.map((variant) => Object.values(variant).join(", ")).join(", ");
};

const formatUsedMobile = (usedMobile) => {
  if (usedMobile === undefined || usedMobile === null) return null;
  return usedMobile === false ? "New" : "Used";
};

/** Subtitle line under product name in list/table views. */
export const formatProductSpecDetails = (
  product,
  { hideRamStorage = false, hideNewUsed = false } = {}
) =>
  [
    ...(hideRamStorage ? [] : [product?.ram, product?.storage]),
    formatVariants(product?.variants),
    product?.suffix,
    ...(hideNewUsed ? [] : [formatUsedMobile(product?.used_mobile)]),
  ]
    .filter(Boolean)
    .join(" | ");

/** Inline spec suffix for product detail header (e.g. " • RAM: 8GB"). */
export const formatProductRamStorageSpec = (product, { hideRamStorage = false } = {}) => {
  if (hideRamStorage) return "";
  return [
    product?.ram ? ` • RAM: ${product.ram}` : "",
    product?.storage ? ` • Storage: ${product.storage}` : "",
  ].join("");
};
